import { Route } from 'react-router';
import React from 'react';
import { getCookie } from '../utils/cookieUtils';

type Props = {
  component: React.FC;
  path: string;
  exact: boolean;
};

const PrivateRoute: React.FC<Props> = (props: Props) => {
  const token = getCookie('accessToken');

  if (!token) {
    window.location.href = process.env.REACT_APP_LOGIN_URL || 'https://login.peoplelens.ai';
    return null;
  }

  return <Route path={props.path} exact={props.exact} component={props.component} />;
};

export default PrivateRoute;
